import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

const WIDTH_CLASS = {
  default: 'w-max max-w-60',
  wide: 'w-max max-w-80',
  fill: 'w-full',
} as const;

type WrappingCellTextWidth = keyof typeof WIDTH_CLASS;

interface WrappingCellTextProps {
  children: ReactNode;
  width?: WrappingCellTextWidth | undefined;
  className?: string | undefined;
}

export function WrappingCellText({
  children,
  width = 'default',
  className,
}: WrappingCellTextProps) {
  return (
    <span className={cn('block whitespace-normal wrap-break-word', WIDTH_CLASS[width], className)}>
      {children}
    </span>
  );
}
